<template>
  <div v-if="contract_manager">
    <h1 class="main-header">
      <translate translate-context="contract_managers"
                 :translate-params="{id: contract_manager.id, name: contract_manager.name}">
        Create Contract - Contract Manager #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton variant="outline" color="secondary" @click="goBack" class="mr-2" v-translate translate-context="form">
            Back
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <ContractForm :data="emptyContract" @save="onCreate" :save_text="$pgettext('form','Create')"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import ContractForm from "@/domain/contract_manager/components/ContractForm.vue";

export default {
  name: 'CreateContract',
  components: {ContractForm},
  data() {
    return {
      loading: true,
      emptyContract: {
        name: null,
        qty: 0,
        event_owner: null,
        template: null,
        vertical: null,
        currency: null,
        is_saas: false,
        is_subscription: false,
        plan_category: null,
        base_plan: null,
        plan: {
          num_photo_included: 0,
          extra_photo_price: 0,
          num_max_photo: 0,
          max_participants: 0,
          is_promo: false,
          is_ecommerce: false,
          pica_fee_perc: 0,
          assigns_transaction_costs_to_pica: false,
        },
        settings: {
          num_photo_included: null,
          num_max_photo: null,
          is_promo: null,
        },
      }
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.id}),
        this.fetchContractManager(this.$route.params.id)
      ])
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
    ]),
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
      'createContract',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async onCreate(data) {
      await this.createContract(data)
      await this.$router.push({
        name: 'contract_manager.contracts', 
        params: {id: this.contract_manager.id}
      })
      throw new SuccessNotification(this.$pgettext('contract_manager', 'Contract created!'))
    },
    goBack() {
      this.$router.push({
        name: 'contract_manager.contracts', 
        params: {id: this.contract_manager.id}
      })
    }
  }
}
</script>